import React from 'react';

import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

import { Root } from './src/components/organisms/Root';

// Avoid auto-injecting Font Awesome CSS at runtime (can cause a size "jump").
config.autoAddCss = false;

export const wrapPageElement = ({ element, props }) => {
  return <Root {...props}>{element}</Root>;
};
